import SessionEventProto from "../session-event-proto";


export default class EventCompanyUsersDeletedReset extends SessionEventProto {


    process() {
        if (this.isDifferentCompany()) return false;

        gd.session.deletedCompanyUsers.resetFromJson(this.data)
    }
}
